import { FC, PropsWithChildren, ReactNode } from 'react';
import styles from './Section.css';
import { Title } from '../Title';
import { clsx } from 'clsx';

interface ISectionProps {
  title?: string;
  subtitleContent?: ReactNode;
  bounded?: boolean;
  dataName?: string;
}

export const Section: FC<PropsWithChildren<ISectionProps>> = ({
  title,
  subtitleContent,
  dataName,
  bounded = true,
  children,
}) => {
  return (
    <section className={styles['section']} data-name={dataName}>
      {title && (
        <div className={styles['title']}>
          <Title>{title}</Title>
        </div>
      )}

      {subtitleContent && <div className={styles['subtitle']}>{subtitleContent}</div>}

      <div className={clsx(styles['content'], bounded && styles['bounded'])}>{children}</div>
    </section>
  );
};
